
const { document } = require('window');

const $ = require('rgs-jquery');
require('bootstrap');

const ExtendedTooltipPlugin = require('./tooltip.js');
const ExtendedTooltipConstructor = ExtendedTooltipPlugin.Constructor;

/*
 * Extended bootstrap popover
 * See `DEFAULTS` for comments on new options
 */


const Popover = $.fn.popover.Constructor;
const Plugin = $.fn.popover;

var ExtendedPopover = function () {
	Popover.apply(this, arguments);
	this.constructor = ExtendedPopover;
	return this;
};

ExtendedPopover.DEFAULTS = {
	// use `$(contentSelector)` itself for popover content
	contentSelector: null,

	// detach tip from document when it's hidden, disabled for knockout compatibility
	detachTip: false,
};

ExtendedPopover.prototype = $.extend({}, Popover.prototype, {
	init: ExtendedTooltipConstructor.prototype.init,
	hide: ExtendedTooltipConstructor.prototype.hide,
	show: ExtendedTooltipConstructor.prototype.show,
	getOptions: function () {
		const opts = Popover.prototype.getOptions.apply(this, arguments);

		if (opts.contentSelector) {
			opts.html = true;
		}

		return opts;
	},
	getContent: function () {
		const $e = this.$element;

		if (this.$content) {
			return this.$content;
		}
		if (this.options.contentSelector) {
			return (this.$content = $(this.options.contentSelector));
		}
		const contentSelectorAttr = $e.attr('data-content-selector');
		if (contentSelectorAttr) {
			return (this.$content = $(contentSelectorAttr));
		}

		return Popover.prototype.getContent.apply(this, arguments);
	},
});

function ExtendedPlugin (option) {
	return this.each(function () {
		const $this = $(this);
		let data	= $this.data('bs.popover');
		const options = typeof option == 'object' && option;

		if (!data && /destroy|hide/.test(option)) {
			return;
		}
		if (!data) {
			$this.data('bs.popover', (data = new ExtendedPopover(this, options)));
		}
		if (typeof option == 'string') {
			data[option]();
		}
	});
}

$.fn.popover = ExtendedPlugin;
$.fn.popover.Constructor = ExtendedPopover;

$.fn.popover.noConflict = function () {
	$.fn.popover = Plugin;
	$.fn.popover.Constructor = Popover;
	return this;
};


$(document).on('click', '[data-dismiss="popover"]', function () {
	const popover = $(this).closest('.popover').data('bs.popover');
	if (!popover) {
		return;
	}
	popover.$element.trigger('click.popover'); // TODO?: use popover api to hide it
});

module.exports = $.fn.popover;

